import { getCurrentVestSite, VEST_ENTITY_APPID } from './siteConfig'

export const APPKEYOBJ = {
  cm2001: 'YNVNJjQMIeQD23wxg6gQAttVYkFryYRQ',
  cm1002: '3TuzgdNr5FC4SxqMv4hWv8kzeaePopFa',
  cm1001: 'jYTcXSIcKTBQlLR4u4TY5DSV2b7+MfLWHPTpTnArumc=',
  cm1003: 'uJBPo3e5hEqGebFfxi8yAEuBELtViMqj'
}

/** 马甲站主体 appid 占位（转发自 siteConfig，便于 CONST 消费方一并引用） */
export { VEST_ENTITY_APPID }

const AppConfig: {
  [key: string]: any
} = {
  // Chapters
  cm1001: {
    appid: 'cm1001',
    logo: require('../assets/images/logo.png'),
    logoShadow: require('../assets/images/logo_shadow.png'),
    bg: require('../assets/images/banner.png'),
    bgSearch: require('../assets/images/banner_short.png'),
    poster: require('../assets/images/banner_poster.png'),
    avatarOfficial: require('../assets/images/official.png')
  },
  // Spotlight
  cm1002: {
    appid: 'cm1002',
    logo: require('../assets/cm1002/logo.png'),
    logoShadow: require('../assets/cm1002/logo.png'),
    bg: require('../assets/cm1002/banner.png'),
    bgSearch: require('../assets/cm1002/banner_short.png'),
    poster: require('../assets/cm1002/banner_poster.png'),
    avatarOfficial: require('../assets/cm1002/official.png')
  },
  // Kiss
  cm1003: {
    appid: 'cm1003',
    logo: require('../assets/cm1003/logo2.png'),
    logoShadow: require('../assets/cm1003/logo2.png'),
    bg: require('../assets/cm1003/banner.png'),
    bgSearch: require('../assets/cm1003/banner_short.png'),
    poster: require('../assets/cm1003/banner_poster.png'),
    avatarOfficial: require('../assets/cm1003/official2.png')
  },
  // Project-J1 (PWK)
  cm1006: {
    appid: 'cm1006',
    logo: require('../assets/cm1006/logo.png'),
    logoShadow: require('../assets/cm1006/logo.png'),
    bg: require('../assets/cm1006/banner.png'),
    bgSearch: require('../assets/cm1006/banner_short.png'),
    avatarOfficial: require('../assets/cm1006/official.png')
  },
  // Project-J2 (Magic)
  cm1007: {
    appid: 'cm1007',
    logo: require('../assets/cm1007/logo.png'),
    logoShadow: require('../assets/cm1007/logo.png'),
    bg: require('../assets/cm1007/banner.png'),
    bgSearch: require('../assets/cm1007/banner_short.png'),
    avatarOfficial: require('../assets/cm1007/official.png')
  },
  // Escape
  cm1008: {
    appid: 'cm1008',
    logo: require('../assets/cm1008/logo.png'),
    logoShadow: require('../assets/cm1008/logo_shadow.png'),
    bg: require('../assets/cm1008/banner.png'),
    bgSearch: require('../assets/cm1008/banner_short.png'),
    poster: require('../assets/cm1008/banner_poster.png'),
    avatarOfficial: require('../assets/cm1008/official.png')
  },
  // Project-V (Reelshort App)
  cm1009: {
    appid: 'cm1009',
    logo: require('../assets/cm1009/logo.png'),
    logoShadow: require('../assets/cm1009/logo.png'),
    bg: require('../assets/cm1009/banner.png'),
    bgSearch: require('../assets/cm1009/banner_short.png'),
    poster: '',
    avatarOfficial: require('../assets/cm1009/official.png')
  },
  // Project-V H5 (ReelShort H5 主站)
  cm1017: {
    appid: 'cm1017',
    logo: require('../assets/cm1017/logo.png'),
    logoShadow: require('../assets/cm1017/logo.png'),
    bg: require('../assets/cm1017/banner.png'),
    bgSearch: require('../assets/cm1017/banner_short.png'),
    poster: '',
    avatarOfficial: require('../assets/cm1017/official.png')
  },
  // Escape
  cm1011: {
    appid: 'cm1011',
    logo: require('../assets/cm1011/logo.png'),
    logoShadow: require('../assets/cm1011/logo_shadow.png'),
    bg: require('../assets/cm1011/banner.png'),
    bgSearch: require('../assets/cm1011/banner_short.png'),
    poster: require('../assets/cm1011/banner_poster.png'),
    avatarOfficial: require('../assets/cm1011/official.png')
  },
  // Myfiction
  cm3002: {
    appid: 'cm3002',
    logo: require('../assets/cm3002/logo.png'),
    logoShadow: require('../assets/cm3002/logo.png'),
    bg: require('../assets/cm3002/banner.png'),
    bgSearch: require('../assets/cm3002/banner_short.png'),
    poster: '',
    avatarOfficial: require('../assets/cm3002/official.png')
  },
  // MaxDrama
  cm1012: {
    appid: 'cm1012',
    logo: require('../assets/cm1012/logo.png'),
    logoShadow: require('../assets/cm1012/logo.png'),
    bg: require('../assets/cm1012/banner.png'),
    bgSearch: require('../assets/cm1012/banner_short.png'),
    poster: '',
    avatarOfficial: require('../assets/cm1012/official.png')
  },
  // RSNovel
  cm1013: {
    appid: 'cm1013',
    logo: require('../assets/cm1013/logo.png'),
    logoShadow: require('../assets/cm1013/logo.png'),
    bg: require('../assets/cm1013/banner.png'),
    bgSearch: require('../assets/cm1013/banner_short.png'),
    poster: '',
    avatarOfficial: require('../assets/cm1013/official.png')
  },
  // MergeWorld
  cm1015: {
    appid: 'cm1015',
    logo: require('../assets/cm1015/logo.png'),
    logoShadow: require('../assets/cm1015/logo.png'),
    bg: require('../assets/cm1015/banner.png'),
    bgSearch: require('../assets/cm1015/banner_short.png'),
    poster: require('../assets/cm1015/banner_poster.png'),
    avatarOfficial: require('../assets/cm1015/official.png')
  },
  // Gorogoro
  cm1018: {
    appid: 'cm1018',
    logo: require('../assets/cm1018/logo.png'),
    logoShadow: require('../assets/cm1018/logo.png'),
    bg: require('../assets/cm1018/banner.png'),
    bgSearch: require('../assets/cm1018/banner_short.png'),
    poster: '',
    avatarOfficial: require('../assets/cm1018/official.png')
  },
  // 马甲站主体 b25（站点级 logo/token 见 siteConfig，运行时由 getAppConfig 合并）
  [VEST_ENTITY_APPID.b25]: {
    appid: VEST_ENTITY_APPID.b25,
    logo: '',
    logoShadow: '',
    bg: '',
    bgSearch: '',
    poster: '',
    avatarOfficial: '',
    isVest: true
  },
  // 马甲站主体 sweet（站点级 logo/token 见 siteConfig，运行时由 getAppConfig 合并）
  [VEST_ENTITY_APPID.sweet]: {
    appid: VEST_ENTITY_APPID.sweet,
    logo: '',
    logoShadow: '',
    bg: '',
    bgSearch: '',
    poster: '',
    avatarOfficial: '',
    isVest: true
  }
}

export const getAppConfig = () => {
  const appid = sessionStorage.getItem('appid')
  const base = appid ? AppConfig?.[appid] : AppConfig?.['cm1001']
  // 马甲站：logo 按当前站点配置表解析（主体 appid 下 4 站各不同）
  if (base?.isVest) {
    const site = getCurrentVestSite()
    if (site?.logo) {
      return {
        ...base,
        logo: site.logo,
        logoShadow: site.lockup || site.logo
      }
    }
  }
  return base
  // return AppConfig?.['cm1008']
}

export const getPageConfig = () => {
  const { appid, logo, logoShadow, bgSearch } = getAppConfig() || {}
  return {
    ...(appid === 'cm1001' && { logo }),
    ...(appid === 'cm1002' && { logo }),
    ...(appid === 'cm1003' && { logo }),
    ...(appid === 'cm1006' && { logo }),
    ...(appid === 'cm1007' && { logo }),
    ...(appid === 'cm1008' && { logo: logoShadow }),
    ...(appid === 'cm1009' && { logo }),
    ...(appid === 'cm1017' && { logo }),
    ...(appid === 'cm1012' && { logo }),
    ...(appid === 'cm1013' && { logo }),
    ...(appid === 'cm1018' && { logo }),
    ...(appid === 'cm1015' && { logo }),
    ...(appid === 'cm3002' && { logo }),
    ...(appid === VEST_ENTITY_APPID.b25 && { logo }),
    ...(appid === VEST_ENTITY_APPID.sweet && { logo }),
    appid,
    bgSearch
  }
}
